module.exports = __webpack_public_path__ + "static/media/PDQ2.8ed2a447.png";